import {
  FEEDBQ_ORG_ID,
  JINGLE_ITEM_PREFIX,
  SECONDARY_ITEM_PREFIX,
  SHOW_ITEM_PREFIX,
} from "../constants/constants";
export const secondsToHHMM = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  const minutes = Math.floor(totalSeconds / 60);
  return `${hours < 10 ? `0${hours}` : hours}:${
    minutes < 10 ? `0${minutes}` : minutes
  }`;
};

export const secondsToHHMMSS = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return `${hours < 10 ? `0${hours}` : hours}:${
    minutes < 10 ? `0${minutes}` : minutes
  }:${seconds < 10 ? `0${seconds}` : seconds}`;
};

export const KBToMB = (kb: number) => {
  return parseFloat(`${kb / 1024}`).toFixed(2);
};

export const getFileDuration = (file: any) =>
  new Promise((resolve, reject) => {
    try {
      let aborted = false;
      try {
        setTimeout(() => {
          if (!aborted) {
            aborted = true;
            reject(new Error("Timed out getting duration"));
          }
        }, 60 * 1000);
        let video = document.createElement("video");
        video.preload = "metadata";

        video.onloadedmetadata = function () {
          window.URL.revokeObjectURL(video.src);
          if (!aborted) {
            aborted = true;
            const duration = (this as HTMLVideoElement).duration;
            resolve(duration);
          }
        };

        video.onerror = function (_err) {
          if (!aborted) {
            aborted = true;
            reject(new Error("Invalid video. Please select a video file."));
          }
        };

        video.src = URL.createObjectURL(file);
      } catch (e) {
        if (!aborted) {
          aborted = true;
          reject(e);
        }
      }
    } catch (_err) {}
  });

export const reorderItems = (
  data: any[],
  startIndex: number,
  endIndex: number,
) => {
  const newItemIds = data.slice();
  const [removed] = newItemIds.splice(startIndex, 1);
  newItemIds.splice(endIndex, 0, removed);
  return newItemIds.map((item, index) => ({ ...item, order: index + 1 }));
};

export const getLastOrder = (data: { order: number }[]) => {
  if (data.length === 0) {
    return 0;
  }
  return data.slice().sort((a, b) => b.order - a.order)[0]?.order || 0;
};

export const updateUserCrispData = ({
  email,
  firstName,
  lastName,
}: {
  email: string;
  firstName: string;
  lastName: string;
}) => {
  const anyWindow = window as any;
  if (typeof window !== "undefined" && anyWindow.$crisp) {
    try {
      if (anyWindow.$crisp.get) {
        const visitorEmail = anyWindow.$crisp.get("user:email");
        if (!visitorEmail) {
          anyWindow.$crisp.push(["set", "user:email", email]);
          anyWindow.$crisp.push([
            "set",
            "user:nickname",
            `${firstName} ${lastName}`,
          ]);
        }
      }
    } catch (err) {}
  }
};

export const getShowItemId = (showId: string, itemId: string) => {
  return `${SHOW_ITEM_PREFIX}${showId}_${itemId}_${Date.now()}`;
};

export const parseShowItemId = (itemId: string) => {
  const parts = itemId.replace(SHOW_ITEM_PREFIX, "").split("_");
  return {
    showId: parts[0],
    itemId: parts[1],
    date: parts[2],
  };
};

export const getJingleItemId = (itemId: string) => {
  return `${JINGLE_ITEM_PREFIX}${itemId}`;
};

export const parseJingleItemId = (itemId: string) => {
  return itemId.replace(JINGLE_ITEM_PREFIX, "");
};

export const getSecondaryItemId = (itemId: string) => {
  return `${SECONDARY_ITEM_PREFIX}${itemId}`;
};

export const parseSecondaryItemId = (itemId: string) => {
  return itemId.replace(SECONDARY_ITEM_PREFIX, "");
};

export const updateFeedBQData = async ({
  id,
  email,
  name,
}: {
  id: string;
  email: string;
  name: string;
}) => {
  if (!FEEDBQ_ORG_ID || !window.FeedBQ) return;
  window.FeedBQ.identifyUser({
    organizationId: FEEDBQ_ORG_ID,
    user: {
      id: id,
      name,
      email: email,
    },
  });
};
